import localForage from 'localforage';

import { type State } from './types';

/*
Cribbed from https://gist.github.com/zensh/4975495, updating from
http://stackoverflow.com/questions/1248302/javascript-object-size
*/
const sizeOf = (obj: State | string | number | boolean): number => {
  let bytes = 0;
  if (obj !== null && obj !== undefined) {
    switch (typeof obj) {
      case 'number':
        bytes += 8;
        break;
      case 'string':
        bytes += obj.length * 2;
        break;
      case 'boolean':
        bytes += 4;
        break;
      case 'object': {
        const objClass = Object.prototype.toString.call(obj).slice(8, -1);
        if (objClass === 'Object' || objClass === 'Array') {
          for (const key in obj) {
            // eslint-disable-next-line max-depth
            if (Object.prototype.hasOwnProperty.call(obj, key)) continue;
            sizeOf(obj[key as keyof typeof obj]);
          }
        } else bytes += obj!.toString().length * 2;
        break;
      }
    }
  }
  return bytes;
};

export const getPersistedStoreSize = (): Promise<number> => {
  let persistedStoreSize = 0;
  return localForage
    .iterate<State, void>(val => {
      persistedStoreSize += sizeOf(val);
    })
    .then(() => persistedStoreSize);
};

export const getStoreSize = (state: State): number => {
  return sizeOf(state);
};
